import React from 'react';
import Summary from '../../register/summary/Summary';
import Header from '../reports/components/Layout/Header';
import withNewDesignStyles from '../../common/hoc/withNewDesignStyles';

const DailySummaryReport = () => (
  <div>
    <Header title="Daily Summary" />
    <div className="o-page-height o-flexbox o-flexbox--column">
      <Summary />
    </div>
  </div>
);

export default withNewDesignStyles(DailySummaryReport);
